export class TextUtils {

  public static getInitials(str: string): string {
    // camelCase → split on case boundary
    const expanded = str.replace(/([a-z])([A-Z])/g, '$1 $2');
    // split on any non-letter/non-digit character (Unicode-aware, keeps Cyrillic etc.)
    const words = expanded.trim().split(/[^\p{L}\p{N}]+/u).filter(Boolean);
    if (words.length === 0) return '';
    return words.slice(0, 2).map(w => w[0].toUpperCase()).join('');
  }
}
